import { render, staticRenderFns } from "./shenheYuceCrm.vue?vue&type=template&id=c4087b90&scoped=true"
import script from "./shenheYuceCrm.vue?vue&type=script&lang=js"
export * from "./shenheYuceCrm.vue?vue&type=script&lang=js"
import style0 from "./shenheYuceCrm.vue?vue&type=style&index=0&id=c4087b90&prod&scoped=true&lang=css"
import style1 from "./shenheYuceCrm.vue?vue&type=style&index=1&id=c4087b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4087b90",
  null
  
)

export default component.exports